import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ItemSearchParams } from 'api/public/types';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { RootState } from 'shared/redux/store';
import { SearchState } from './types';

const initialState: SearchState = {};

export const searchSlice = createSlice({
  name: 'searchSlice',
  initialState,
  reducers: {
    saveSearchKeyword(state, action: PayloadAction<ItemSearchParams['text']>) {
      const updatedItems = [action.payload, ...(state.histories || [])];

      state.histories = updatedItems
        .filter((element, index) => updatedItems.indexOf(element) === index)
        .slice(0, 10);
    },
    emptyHistories(state) {
      state.histories = [];
    },
  },
  // extraReducers: (builder) => {
  //   builder.addMatcher(
  //     b2bApi.endpoints.searchItem.matchFulfilled,
  //     (state, action: PayloadAction<B2BItem[]>) => {
  //       console.log(action.payload);
  //     }
  //   );
  // },
});

export const searchReducer = persistReducer(
  {
    key: 'search',
    storage,
    whitelist: ['histories'],
  },
  searchSlice.reducer
);

// SELECTOR
export const selectSearchHistories = (state: RootState) =>
  state.searchSlice.histories;
